import { render, staticRenderFns } from "./diseaseLabel.vue?vue&type=template&id=bc9d7bee&scoped=true"
import script from "./diseaseLabel.vue?vue&type=script&lang=js"
export * from "./diseaseLabel.vue?vue&type=script&lang=js"
import style0 from "./diseaseLabel.vue?vue&type=style&index=0&id=bc9d7bee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9d7bee",
  null
  
)

export default component.exports